module.exports = __webpack_public_path__ + "static/assets/2afe9c81ed327ae2f01daf5367a465ff.gif";